import React from 'react'

import { isNil } from 'ramda'

import { Flex, Link, Text } from '@driftt/dds'
import { CubeQueryStringAdapter } from '@driftt/dds.reports'

import { ReportKPICard, Score } from 'components/KPICard'
import { ROI_OPPORTUNITY_REPORT_PATH } from 'layouts/RevenueReport/RevenueReport.constants'
import { TypeFormats } from 'utils/format'

import useInfluencedSalesCycle from './SalesCycle.hooks'

export const SalesCycle = ({ isInfluenced, isSourced }) => {
  const {
    averageDaysInCycleOfInfluencedOpportunities,
    percentageResult,
    hasNoData,
    hasError,
    isLoading,
    salesCycleInfluencedCubeQuery,
  } = useInfluencedSalesCycle({
    isInfluenced,
    isSourced,
  })

  const drillDownQueryString = CubeQueryStringAdapter.toQueryString(
    salesCycleInfluencedCubeQuery
  )

  const action = isInfluenced ? 'influenced' : isSourced ? 'sourced' : ''

  return (
    <ReportKPICard
      title="Sales Cycle"
      isLoading={isLoading}
      isError={hasError}
      hasNoData={hasNoData}
      subtitle={`How fast deals ${action} by Drift are closing`}
      score={Score.None} // NOTE: There is no way for us to tell the score for all organizations so we are leaving it blank for now
      metric={averageDaysInCycleOfInfluencedOpportunities}
      metricRange={''} // NOTE: As of today we have no way to tell this for each org.
      formatMetric={(responseRate: number) => {
        return `${!responseRate ? 0 : TypeFormats.ROUND(responseRate)} days `
      }}
      childrenFlexGap={2}
    >
      {!isNil(averageDaysInCycleOfInfluencedOpportunities) && (
        <Text variant="body">
          <b>Average</b> {`on deals ${action} by Drift`}
        </Text>
      )}
      {!!averageDaysInCycleOfInfluencedOpportunities && (
        <Flex gap="half" direction="column" grow={0}>
          <Text variant="bodyBold">
            {percentageResult
              ? `${TypeFormats.PERCENT(percentageResult)} less than`
              : '--'}
          </Text>
          <Text variant="metadata">deals non-influenced by Drift</Text>
        </Flex>
      )}
      <Link
        target="_blank"
        variant="inline"
        href={`${ROI_OPPORTUNITY_REPORT_PATH}?${drillDownQueryString}`}
      >
        View data
      </Link>
    </ReportKPICard>
  )
}
